import { Controller } from "@hotwired/stimulus"

// Berechnet den Gesamtbetrag live: Tickets × Ticketpreis + ggf. Versand.
export default class extends Controller {
  static targets = ["tickets", "shipping", "total"]
  static values = { ticket: Number, shippingCost: Number } // jeweils in Cent

  connect() {
    this.update()
  }

  update() {
    const tickets = this.clamp(parseInt(this.ticketsTarget.value, 10) || 1)
    this.ticketsTarget.value = tickets
    const shipping = this.hasShippingTarget && this.shippingTarget.checked ? this.shippingCostValue : 0
    const cents = tickets * this.ticketValue + shipping
    this.totalTarget.textContent = this.format(cents)
  }

  increment() {
    this.ticketsTarget.value = this.clamp((parseInt(this.ticketsTarget.value, 10) || 1) + 1)
    this.update()
  }

  decrement() {
    this.ticketsTarget.value = this.clamp((parseInt(this.ticketsTarget.value, 10) || 1) - 1)
    this.update()
  }

  clamp(value) {
    const min = parseInt(this.ticketsTarget.min, 10) || 1
    const max = parseInt(this.ticketsTarget.max, 10) || 99
    return Math.min(Math.max(value, min), max)
  }

  format(cents) {
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(cents / 100)
  }
}
